import angular from 'angular';

import Component from './row-manager-row.component';

const Module = angular
    .module('control-room.commons.form.row-manager.components.row-manager-row', [])
    .component('crRowManagerRow', Component);

export default Module;
